import styled from '@emotion/styled';
import Button, { ButtonVariants } from '@features/ui-form/components/Button/Button';
import { ReactNode } from 'react';

interface SidePanelTemplateProps {
  children: ReactNode;
  closeSidePanel: () => void;
  title?: ReactNode;
  controls?: ReactNode;
}

export const SidePanelTemplate = ({
  children,
  closeSidePanel,
  title,
  controls,
}: SidePanelTemplateProps): JSX.Element => (
  <SidePanelContainer>
    <SidePanelHeader>
      <SidePanelTitle>{title}</SidePanelTitle>
      <div>{controls}</div>
      <Button startDecorator="X" variant={ButtonVariants.PRIMARY} onClick={closeSidePanel} />
    </SidePanelHeader>
    <div>{children}</div>
  </SidePanelContainer>
);

const SidePanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  padding: 1rem 1rem;
`;

const SidePanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const SidePanelTitle = styled.h3`
  margin-right: auto;
  font-size: 1.5rem;
`;
